import { CategoryService } from './../../core/services/category/category.service';
import { Component, OnInit, signal } from '@angular/core';
import { RoleService } from '../../core/services/role.service';
import { DropdownComponent } from '../../shared/components/dropdown/dropdown.component';
import { ModalComponent } from '../../shared/components/modal/modal.component';
import { ModalService } from '../../core/services/modal/modal.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Category } from '../../models/category';
import { InstanceListComponent } from '../instance-list/instance-list.component';
import { InstanceService } from '../../core/services/instance/instance.service';
import { Instance } from '../../models/instance';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { CustomerService } from '../../core/services/customer.service';
import { AgentWritableDirective } from '../../shared/directives/agent-writable.directive';
import { LoadingSpinnerComponent } from '../../shared/components/loading-spinner/loading-spinner.component';
import { IconMoreActionsComponent } from '../../shared/components/icon-more-actions/icon-more-actions.component';
import { AlertComponent } from '../../shared/components/alert/alert.component';
import { EmptyStateComponent } from '../../shared/components/empty-state/empty-state.component';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { InputComponent } from '../../shared/components/input/input.component';

@Component({
  selector: 'app-categories-list',
  standalone: true,
  imports: [
    DropdownComponent,
    ModalComponent,
    ReactiveFormsModule,
    InstanceListComponent,
    TranslatePipe,
    AgentWritableDirective,
    LoadingSpinnerComponent,
    IconMoreActionsComponent,
    AlertComponent,
    EmptyStateComponent,
    ButtonComponent,
    InputComponent
  ],
  templateUrl: './categories-list.component.html',
  styleUrl: './categories-list.component.css'
})

export class CategoriesListComponent implements OnInit {

  modalValue = signal(0);
  isAgent: boolean;
  optionItems: any[] = [];
  categories: Category[];
  instances: Instance[];
  instanceNumber: number;
  categorySelected: number;
  currentCategory: number;
  category: Category | undefined;
  categoryForm!: FormGroup;
  loading: boolean = false;
  showInstance: boolean = false;
  errorMessage: string = '';
  isSaving: boolean = false;
  public customerId: number | null = null;

  constructor(
    private roleService: RoleService,
    private modalService: ModalService,
    private _fb: FormBuilder,
    private categoryService: CategoryService,
    private instanceService: InstanceService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private customerService: CustomerService
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.isAgent = this.roleService.isAgent();

    if (this.customerService.getIsJubooAgent()) {
      this.customerService.selectedCustomer$.subscribe((customer) => {
        if (customer) {
          this.customerId = customer.id;
          console.log("customerId from agent selection", this.customerId);
          this.getAllCategories();
        }
      });
    } else {
      const currentUserRaw = localStorage.getItem('currentUser');
      if (currentUserRaw) {
        try {
          const currentUser = JSON.parse(currentUserRaw);
          if (currentUser && currentUser.customerId) {
            this.customerId = Number(currentUser.customerId);
            console.log("customerId from storage", this.customerId);
            this.getAllCategories();
          }
        } catch (e) {
          console.warn('Unable to parse currentUser from storage', e);
        }
      }
    }
  }

  private resolveCustomerContext(): void {
    console.log("_____________________");
    const routeId = this.route.snapshot.paramMap.get('id');
    if (routeId) {
      this.customerId = Number(routeId);
      console.log("customerId from route", this.customerId);
      return;
    }

  }



  initForm() {
    this.categoryForm = this._fb.group({
      name: ["", Validators.required],
      code: [""],
      description: [""]
    });
  }

  onDropdownClick(id: number): void {
    this.optionItems = [
      {
        label: 'Editer',
        callback: () => {
          this.onCategorySelected(id);
          this.openModal(1);
        },
      },
      {
        label: 'Supprimer',
        callback: () => {
          this.onCategorySelected(id);
          this.openModal(2);
        }
      }
    ];
  }

  onCategorySelected(categoryId: number) {
    this.categorySelected = categoryId;
    this.getCategoryById();
  }

  getCategoryById(): void {
    this.categoryService.getCategoryById(this.categorySelected).subscribe(
      (res) => {
        this.category = res;
        this.categoryForm.patchValue({
          name: this.category?.name,
          code: this.category?.code,
          description: this.category?.description
        })
      },
      (err) => {
        console.log(`An error occurs ${err}`);
      }
    );
  }

  openModal(value: number) {
    this.category = undefined;
    switch (value) {
      case 1: this.modalValue.set(1);
        this.categoryForm.reset();
        this.modalService.openModal();
        break;
      case 2: this.modalValue.set(2);
        this.modalService.openModal();
        break;
      default: console.log("Can't open modal");
    }
  }

  closeModal() {
    this.modalValue.set(0);
    this.modalService.closeModal();
  }

  SwitchToCategory(category: Category) {
    this.category = category;
    this.currentCategory = category.id;
    this.getAllInstances(category.id);
  }

  getAllCategories() {
    this.loading = true;
    const request$ = this.customerId !== null
      ? this.categoryService.getCategoriesByCustomer(this.customerId)
      : this.categoryService.getAllCategories();
    request$.subscribe(
      (res) => {
        this.categories = res;
        if (this.categories.length > 0) {
          this.category = this.categories[0];
          this.getAllInstances(this.categories[0].id);
          this.currentCategory = this.categories[0].id;
        }
        this.loading = false;
      },
      (err) => {
        console.log('err: ' + err);
        this.loading = false;
      }
    );
  }

  getAllInstances(categoryId: number) {
    this.showInstance = true;
    this.instanceService.getInstanceByCategory(categoryId).subscribe(
      (res) => {
        this.showInstance = false;
        this.instances = res.sort((instance1, instance2) => {
          return instance1.name.localeCompare(instance2.name);
        });
        this.instanceNumber = this.instances.length;
      },
      (err) => {
        this.showInstance = false;
        console.log('err: ' + err);
      }
    );
  }

  createCategory() {
    if (!this.categoryForm.valid) {
      this.categoryForm.markAllAsTouched();
    }
    else {
      const customerId = this.customerId;
      if (!customerId) {
        this.modalService.notifier("Veuillez sélectionner un client.", "", "error");
        return;
      }
      this.isSaving = true;
      this.categoryService.createCategoryForCustomer(customerId, this.categoryForm.value).pipe(
        finalize(() => {
          this.isSaving = false;
        })
      ).subscribe(
        (res) => {
          this.getAllCategories();
          this.modalService.closeModal();
          this.modalValue.set(0);
          this.modalService.notifier("Catégorie crée avec succès.", "", "success");
        },
        (err) => {
          console.log('err: ' + err);
          this.modalService.notifier("Échec de la création. Veuillez réessayer.", "", "error");
        }
      );
    }
  }

  updateCategory(): void {
    const category = this.category;

    if (!category || category.id === undefined) {
      return;
    }
    const customerId = this.customerId;
    if (!customerId) {
      this.modalService.notifier("Veuillez sélectionner un client.", "", "error");
      return;
    }
    this.isSaving = true;
    this.categoryService.updateCategoryForCustomer(customerId, category?.id, {
      id: this.category?.id,
      name: this.categoryForm.value.name,
      code: this.categoryForm?.value.code,
      description: this.categoryForm.value.description
    }).pipe(
      finalize(() => {
        this.isSaving = false;
      })
    ).subscribe(
      (res) => {
        this.categoryForm.reset();
        this.getAllCategories();
        this.modalValue.set(0);
        this.modalService.closeModal();
        this.modalService.notifier("Catégorie mise à jour avec succès.", "", "success");
      },
      (err) => {
        this.modalValue.set(0);
        this.modalService.notifier("Erreur lors de la mise à jour.", "", "error");
      }
    );
  }

  deleteCategory() {
    const customerId = this.customerId;
    if (!customerId) {
      this.modalService.notifier("Veuillez sélectionner un client.", "", "error");
      return;
    }
    this.categoryService.deleteCategoryForCustomer(customerId, this.categorySelected).subscribe(
      (res) => {
        this.getAllCategories();
        this.modalValue.set(0);
        this.modalService.closeModal();
        this.modalService.notifier("Catégorie supprimée avec succès.", "", "success");
      },
      (err) => {
        this.modalValue.set(0);
        this.modalService.closeModal();
        this.modalService.notifier("Impossible : categorie liée à une description.!", "", "error");
      }
    )
  }

  saveCategory() {
    if (this.category) {
      this.updateCategory();
    } else {
      this.createCategory();
    }
  }
}
